import { handleClickColor, timezones } from "../../Common/Util";

export function ClientInformation ({userData,clientData}) {
  return(
    <>
      <table class="m-0 p-0 table">
        <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Client Information</h4></caption>
      </table>
      <div class="m-0 p-0 row">
        <div class="m-0 p-0 col-12 col-md-6">
          <table class="m-0 p-0 table table-borderless table-hover">
            <tbody class="m-0 p-0">
              <tr class="m-0 p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 w-50 bg-transparent text-start">Id</th>
                <td class="m-0 p-1 w-50 bg-transparent text-start">{userData.runningId}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Name</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.firstName+" "+userData.lastName}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Father Name</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.fatherName}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Sex</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.sex}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Email</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.email}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Mobile</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.mobile}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Birth Date</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.birthDate}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Birth Time</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.birthTime}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Birth Time Corrected</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.birthTimeCorrected}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Birth Day</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.birthDay}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Birth Timezone</th>
                <td class="m-0 p-1 bg-transparent text-start">{timezones.find(tz => tz.value === userData.birthTimezone).label.substring(1,10)}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Birth Place</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.birthCity}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Latitude</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.birthLatitude}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Longitude</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.birthLongitude}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Marital Status</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.maritalStatus}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Marriage Date</th>
                <td class="m-0 p-1 bg-transparent text-start">{userData.marriageDate===null?"":userData.marriageDate.substring(0,10)}</td>
              </tr>
            </tbody>
          </table>  
        </div>
        <div class="m-0 p-0 col-12 col-md-6">
          <table class="m-0 p-0 table table-borderless table-hover">
            <tbody class="m-0 p-0">
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 w-50 bg-transparent text-start">Star</th>
                <td class="m-0 p-1 w-50 bg-transparent text-start">{clientData.starName+" ("+clientData.pathamNumber+")"}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Star Lord</th>
                <td class="m-0 p-1 bg-transparent text-start">{clientData.starLord}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Sign</th>
                <td class="m-0 p-1 bg-transparent text-start">{clientData.signName}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Sign Lord</th>
                <td class="m-0 p-1 bg-transparent text-start">{clientData.signLord}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Lagna</th>
                <td class="m-0 p-1 bg-transparent text-start">{clientData.cuspalSignName}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Lagna Lord</th>
                <td class="m-0 p-1 bg-transparent text-start">{clientData.cuspalSignLord}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Thithi</th>
                <td class="m-0 p-1 bg-transparent text-start">{clientData.thithiName}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Thithi Type</th>
                <td class="m-0 p-1 bg-transparent text-start">{clientData.thithiTypeName2+" ("+clientData.thithiTypeName+")"}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Ayanamsa</th>
                <td class="m-0 p-1 bg-transparent text-start">{clientData.ayanamsaDegree}</td>
              </tr>
              <tr class="p-0" onClick={handleClickColor}>
                <th class="m-0 p-1 bg-transparent text-start">Ayanamsa Name</th>
                <td class="m-0 p-1 bg-transparent text-start">{clientData.ayanamsaName}</td>
              </tr>
            </tbody>
          </table>  
        </div>
      </div>  
    </>
  );
}